<template>
    <header class="sticky-top" :data-target="target">
        <scrollactive class="navbar navbar-expand-lg" :clickToScroll="$root.clickToScroll" :offset="offset" v-on:itemchanged="onScrollActive">
            <a class="navbar-brand" href="/">
                <img alt="" height="40" src="../assets/logo-min.svg">
            </a>
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar-main" aria-controls="navbar-main" aria-expanded="false" aria-label="Toggle navigation">
                <font-awesome-icon icon="bars" />
            </button>

            <div class="collapse navbar-collapse" id="navbar-main">
                <ul class="navbar-nav ml-auto mr-auto">
                    <li class="nav-item" v-for="(item, index) in $root.navbar" v-bind:key="index">
                        <a class="nav-link scrollactive-item" :href="item.href" @click.prevent="onMenuClick">{{item.text}}</a>
                    </li>
                </ul>
            </div>
        </scrollactive>
    </header>
</template>

<script>
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faBars } from '@fortawesome/free-solid-svg-icons';
    import $ from 'jquery';

    library.add(faBars);

    const OFFSET = 100;

    export default {
        name: 'Header',

        data() {
            return {
                target: 'home',
                offset: OFFSET,
            };
        },

        methods: {
            onResize(event) {
                if (event.target.innerWidth < 992) {
                    this.offset = event.target.innerHeight < 500 ? 240 : 360;
                } else {
                    this.offset = OFFSET;
                }
            },

            onScrollActive(event, currentItem) {
                this.target = $(currentItem).attr('href');
                this.$root.currentSection = this.target;
            },

            onMenuClick(event) {
                if (!this.$root.clickToScroll) {
                    this.$router.push({ name: 'home' }).then(() => {
                        window.setTimeout(() => {
                            event.target.dispatchEvent(new Event('click'));
                        }, 600);
                    });
                }

                $('#navbar-main').collapse('hide');
            },
        },

        mounted() {
            $(window).on('resize', this.onResize).trigger('resize');
        },
    };
</script>

<style lang="scss">
    @import '../scss/variables';

    header {
        .navbar-brand {
            img {
                transition: height .2s linear;
            }
        }
        .navbar-toggler {
            @include font-size(40px);
            color: $color_3;
        }
        nav {
            padding-left: 0;
            padding-right: 0;
            background: #fff;
            ul {
                > li {
                    > .nav-link {
                        color: #60627a;
                        position: relative;
                        padding-top: 1.5rem;
                        padding-bottom: 1.5rem;
                        &:hover, &.is-active {
                            color: #5045a6;
                        }
                        &.is-active {
                            font-weight: 500;
                        }
                        @media (max-width: 991px) {
                            & {
                                @include font-size(16px);
                                font-weight: 500;
                                padding: 1rem 0;
                                text-align: center;
                            }
                        }
                        @media (max-height: 400px) {
                            padding: .5rem 0;
                        }
                    }
                }
            }
        }
        @media (min-width: 992px) {
            .navbar-expand-lg .navbar-nav .nav-link {
                padding-right: 1rem;
                padding-left: 1rem;
            }
            .navbar-brand {
                display: none;
            }
        }
    }
</style>
